export const setCookie = (cname, cvalue, exdays) => {
    const date = new Date();
    date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
    // @ts-ignore
    const expires = 'expires=' + date.toGMTString();
    document.cookie = `${cname}=${encodeURIComponent(
        cvalue
    )};${expires}; path=/; domain=9fzt.com`;
};

export const delCookie = (cname) => {
    setCookie(cname, '', -1);
};

export const getCookie = (cname) => {
    let arr;
    const reg = new RegExp('(^| )' + cname + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg))) {
        return decodeURIComponent(arr[2]);
    } else {
        return '';
    }
};